import {Button, Typography} from '@mui/material'
import PropTypes from 'prop-types'

import MaskIcon from './MaskIcon'
import UnmaskIcon from './UnmaskIcon'

import './maskTextButton.scss'

const MaskTextButton = ({
  className = '',
  showText,
  toggleButton
}) => (
  <Button
    className={['mask-text-button', className].filter(Boolean).join(' ')}
    disableRipple
    onClick={toggleButton}
    variant='text'>
    {showText ?
      <MaskIcon className='mask-icon' /> :
      <UnmaskIcon className='mask-icon' />}
    <Typography component='span'>
      {showText ? 'Hide' : 'Show'}
    </Typography>
  </Button>
)

MaskTextButton.propTypes = {
  className: PropTypes.string,
  showText: PropTypes.bool.isRequired,
  toggleButton: PropTypes.func.isRequired
}

export default MaskTextButton
